var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeaminboxOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.665 0.664978H4.66498C2.45584 0.664978 0.664978 2.45584 0.664978 4.66498V12.665C0.664978 14.8741 2.45584 16.665 4.66498 16.665H14.665C16.8741 16.665 18.665 14.8741 18.665 12.665V4.66498C18.665 2.45584 16.8741 0.664978 14.665 0.664978Z",
    stroke: "#606060",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.664978 8.66498H5.66498C5.66498 9.46063 5.98105 10.2237 6.54366 10.7863C7.10627 11.3489 7.86933 11.665 8.66498 11.665C9.46063 11.665 10.2237 11.3489 10.7863 10.7863C11.3489 10.2237 11.665 9.46063 11.665 8.66498H18.665",
    stroke: "#606060",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeaminboxOutlined);
export default __webpack_public_path__ + "static/media/teaminbox_outlined.f6679f25cbe8ee0d9ea8c669ff03b882.svg";
export { ForwardRef as ReactComponent };